import axios from "axios";
import { API_BASE_URL } from "../../app/utils";

export const requestOtp = data => axios.post(`${API_BASE_URL}/user-store/v1/users/register-otp`, data);

export const signUp = data => axios.post(`${API_BASE_URL}/user-store/v1/users`, data);